import React, { useState, useRef, useEffect } from "react";
import { Table } from "antd";
import { Icon } from "@iconify/react";
import DelTableRowModal from "../../modals/delTableRowModal";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CaseDetailModal from "../../modals/caseDetailModal";
import { useTranslation } from "react-i18next";
import { getAllCases } from "../../APIs/caseApis";

const Files = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const datePickerRef = useRef(null); // Create a ref for DatePicker
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [iscaseDetailOpen, setiscaseDetailOpen] = useState(false);
 
  const [cases, setCases] = useState([]); // State for storing cases

  // Fetch cases when the component loads
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await getAllCases();
        setCases(response.data); // Assuming API returns { success: true, data: [...] }
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, []);

  


  const handleDateChange = (date) => {
    setSelectedDate(date); 
  };
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const onviewClick = () => {
    setiscaseDetailOpen(true);
  };
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };
  const months = [
    "Client Information",
    "Contract Management",
    "Evidence Management",
    "Incident Details",
  ];
  // const data = [
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  // ];
  const columns = [
    {
      title: t("adminDashboard.files.id"),
      dataIndex: "caseId",
      key: "caseId",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.caseNumber"),
      dataIndex: "case_number",
      key: "case_number",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.clientName"),
      dataIndex: "client_name",
      key: "client_name",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.tableTitle"),
      dataIndex: "title",
      key: "title",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.caseType"),
      dataIndex: "case_type",
      key: "case_type",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.deadline"),
      dataIndex: "deadline_date",
      key: "deadline_date",
      render: (text) => (
        <span className="text-[#000] font-medium">
          {new Date(text).toLocaleDateString()}
        </span>
      ),
    },
    {
      title: t("adminDashboard.files.courtDate"),
      dataIndex: "court_date",
      key: "court_date",
      render: (text) => (
        <span className="text-[#000] font-medium">
          {new Date(text).toLocaleDateString()}
        </span>
      ),
    },
    {
      title: t("adminDashboard.files.assignedLawyer"),
      dataIndex: "assigned_lawyer",
      key: "assigned_lawyer",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.opposingCounsel"),
      dataIndex: "opposing_counsel",
      key: "opposing_counsel",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.files.uploadDate"),
      dataIndex: "upload_date",
      key: "upload_date",
      render: (text) => (
        <span className="text-[#000] font-medium">
          {new Date(text).toLocaleDateString()}
        </span>
      ),
    },
    {
      title: t("adminDashboard.files.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[8px] items-center">
          <img
            src="../../assets/icons/eye.png"
            alt=""
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onviewClick}
          />
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  

  // const columns = [
  //   {
  //     title: t("adminDashboard.files.id"),
  //     dataIndex: "id",
  //     key: "id",
  //     render: (text) => <span className="text-[#000] font-medium">{text}</span>,
  //   },
  //   {
  //     title: t("adminDashboard.files.tableTitle"),
  //     dataIndex: "title",
  //     key: "title",
  //     render: (text) => <span className="text-[#000] font-medium">{text}</span>,
  //   },
  //   {
  //     title: t("adminDashboard.files.category"),
  //     dataIndex: "category",
  //     key: "category",
  //     render: (text) => <span className="text-[#000] font-medium">{text}</span>,
  //   },
  //   {
  //     title: t("adminDashboard.files.deadline"),
  //     dataIndex: "deadline",
  //     key: "deadline",
  //     render: (text) => <span className="text-[#000] font-medium">{text}</span>,
  //   },
  //   {
  //     title: t("adminDashboard.files.uploadBy"),
  //     dataIndex: "uploadBy",
  //     key: "uploadBy",
  //     render: (text) => <span className="text-[#000] font-medium">{text}</span>,
  //   },
  //   {
  //     title: t("adminDashboard.files.actions"),
  //     key: "actions",
  //     render: () => (
  //       <div className="flex gap-[8px]  items-center">
  //         <img
  //           src="../../assets/icons/eye.png"
  //           alt=""
  //           className="cursor-pointer w-[34px] h-[34px]"
  //           onClick={onviewClick}
  //         />
  //         <img
  //           src="../../assets/icons/del.png"
  //           alt=""
  //           className="cursor-pointer w-[34px] h-[34px]"
  //           onClick={onDelClick}
  //         />
  //       </div>
  //     ),
  //   },
  // ];
  return (
    <>
      <div className="files-main py-[43px] flex flex-col gap-[35px]">
        <h5 className="text-blue font-bold">{t("adminDashboard.files.title")}</h5>
        <div className="bottom">
          <div className="filter-div bg-white rounded-t-[20px] gap-[20px] md-m:gap-[10px] flex items-center justify-between md-m:flex-col py-[22px] pr-[20px] pl-[15px]">
            <div className="left-div gap-[20px] flex items-center max-sm:flex-col">
              <Icon
                icon="solar:filter-bold-duotone"
                color="#143A62"
                width={22}
                height={22}
                className="max-sm:hidden"
              />
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">{t("adminDashboard.filesUpload.category")}:</p>
                <Select
                  placeholder={t("adminDashboard.filesUpload.all")}
                  style={{ width: 148 }}
                  className="admin-dropdown"
                >
                  {months.map((month, index) => (
                    <Option key={index} value={month}>
                      {month}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">{t("adminDashboard.filesUpload.date")}:</p>
                <div className="flex items-center gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)]  bg-[#F0F0F0]">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat"
                    dateFormat="MM/dd/yyyy"
                    ref={datePickerRef} // Assign the ref to DatePicker
                  />
                  <Icon
                    icon="clarity:date-line"
                    className="text-gray-500 cursor-pointer"
                    onClick={handleIconClick} // Trigger DatePicker on icon click
                  />
                </div>
              </div>
            </div>
            <div className="py-[15px] flex items-center gap-[5px] border-b border-solid border-b-[#B8C0CB]">
              <input type="search" name="" id="" placeholder="Search " />
              <Icon icon="si:search-line" color="#143A62" width={22} height={22} />
            </div>
          </div>
          <Table
            columns={columns}
            // dataSource={data}
            dataSource={cases}

            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div>
      </div>
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
      <CaseDetailModal
        iscaseDetailOpen={iscaseDetailOpen}
        setiscaseDetailOpen={setiscaseDetailOpen}
      />
    </>
  );
};

export default Files;
